import {
  TGetNewbuildingPromoPinsForMapResponse_1,
  IGetNewbuildingPromoPinsForMapResponse200,
  IGetNewbuildingPromoPinsForMapResponse400,
  TGetNewbuildingPromoPinsForMapResponseError,
} from 'shared/common/repositories/search-offers-index/v1/get-newbuilding-promo-pins-for-map';

export const mapGetNewbuildingPromoPinsForMapResponse = (
  response: TGetNewbuildingPromoPinsForMapResponse_1,
): IGetNewbuildingPromoPinsForMapResponse200 => {
  return {
    statusCode: 200,
    headers: [],
    response,
  };
};

export const mapGetNewbuildingPromoPinsForMapResponseError = (
  response: TGetNewbuildingPromoPinsForMapResponseError,
): IGetNewbuildingPromoPinsForMapResponse400 => {
  return {
    statusCode: 400,
    headers: [],
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
